import React from "react";

import * as Icons from "./Icons";

const componentsObject = { ...Icons };

export type IconType = keyof typeof componentsObject;

interface Props {
  type: IconType;
  className?: string;
  width?: number;
  height?: number;
  onClick?: () => void;
  dataQA: string;
  style?: Object;
}

const Icon: React.FC<Props> = ({ type, dataQA, ...props }) => {
  const Component = componentsObject[type];

  return Component && <Component {...props} data-qa={dataQA} />;
};

export default Icon;
